import PropTypes from "prop-types";
import React from "react";

const Input = ({
  type,
  placeholder,
  value,
  onChange,
  label,
  "data-testid": dataTestId,
}) => {
  return (
    <input
      className="w-1/2 min-w-48 p-2 m-8 border border-roseBrown bg-white rounded-md focus:outline-none focus:ring-2 focus:ring-salmonPink"
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      aria-label={label}
      data-testid={dataTestId}
      required
    />
  );
};

Input.propTypes = {
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  "data-testid": PropTypes.string,
};

export default Input;
